import type { ReactElement, ReactNode } from 'react'
import { cn } from '@/lib/cn'

export interface EmptyStateProps {
  icon?: ReactNode
  title: string
  description?: string
  action?: ReactNode
  className?: string
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className
}: EmptyStateProps): ReactElement {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 px-6 py-14 text-center',
        className
      )}
    >
      {icon ? (
        <span
          aria-hidden="true"
          className="grid size-12 place-items-center rounded-card border border-line bg-sunken text-fg-subtle [&_svg]:size-6"
        >
          {icon}
        </span>
      ) : null}
      <div className="max-w-sm space-y-1.5">
        <h3 className="text-base font-semibold text-fg">{title}</h3>
        {description ? (
          <p className="text-sm leading-relaxed text-fg-muted">{description}</p>
        ) : null}
      </div>
      {action ? <div className="pt-1">{action}</div> : null}
    </div>
  )
}
